export { KakaoPayDisabledIcon, KakaoPayIcon } from './kakao-pay-icon'
